<!--
 * @Description: 游戏管理中的分组列表
 * @Author: gao shuai
 * @Date: 2020-02-23 14:13:50
 * @LastEditTime: 2020-09-11 09:42:09
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
        <el-breadcrumb-item>分组列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="tenantId" @input="tenantId=intNumber(tenantId)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>商户账号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="accountnumber" placeholder="请输入内容"></el-input>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="()=>{pageIndex=1;getlist()}">查询</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="index" label="编号" width="80">
        </el-table-column>
        <el-table-column prop="name" label="分组名称">
        </el-table-column>
        <el-table-column label="商户名/账号">
          <template slot-scope="scope">
            <p style="color:#010101">{{scope.row.tenantName}}</p>
            <p style="color:#969a9b;">{{scope.row.tenantAccount}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="分区数量">
          <template slot-scope="scope">
            <p style="color:#b03f3f">{{scope.row.partitionCount}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="groupUuid" label="分组标识" width='330'>
        </el-table-column>
        <el-table-column label="操作" width='200'>
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="recharge(scope.row.groupUuid)">充值</el-button>
            <!-- <el-button size="mini" type="danger" @click.prevent="handleClose(scope.row.id)">删除</el-button> -->
            <el-button size="mini" type="primary" :disabled="scope.row.partitionCount===0" @click="clickcheck(scope.row.id)">查看分区</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 查看分区弹框 -->
    <el-dialog title="分区" :visible.sync="subarea" @close="dialoginit" custom-class="gs_dialog" width="1100px">
      <div class="gs_tablebox" style="padding-bottom:25px;">
        <el-table ref="moduleTable" size="mini" :data="checkarea" border style="width: 100%;"  max-height="600" stripe>
          <el-table-column type="index" label="编号" width="60">
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110">
            <template slot-scope="scope">
              <p style="color:#010101;height:18px;">{{scope.row.createDate.split(' ')[0]}}</p>
              <p style="color:#969a9b;height:18px;">{{scope.row.createDate.split(' ')[1]}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="分区名称" width="240">
          </el-table-column>
          <el-table-column prop="useDate" label="开区时间" width="110">
            <template slot-scope="scope">
              <p style="color:#010101;height:18px;">{{scope.row.useDate.split(' ')[0]}}</p>
              <p style="color:#969a9b;height:18px;">{{scope.row.useDate.split(' ')[1]}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="useName" label="开区使用名称" width="120">
          </el-table-column>
          <el-table-column prop="serverIp" label="通讯IP">
          </el-table-column>
          <el-table-column prop="serverPort" label="通讯端口">
          </el-table-column>
          <el-table-column prop="scriptPath" label="分区目录">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tenantId: '', // 商户Id
      accountnumber: '', // 商户账号
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      options: [],
      tableData: [],
      checkarea: [], // 查看分区
      subarea: false
    };
  },
  methods: {
    // 分组list
    getlist() {
      this.$api.game
        .grouplist({
          Id: this.tenantId,
          Account: this.accountnumber,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 查看分区
    async clickcheck(data) {
      this.$api.game
        .groupcheck({
          groupId: data
        })
        .then((data) => {
          if (data.status === 200) {
            this.checkarea = data.data;
            this.subarea = true;
            this.$nextTick(() => {
              this.$refs.moduleTable.doLayout();
            });
          } else if (data.status === 204) {
            this.checkarea = [];
            this.subarea = true;
            this.$nextTick(() => {
              this.$refs.moduleTable.doLayout();
            });
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 充值
    recharge(uuid) {
      var tempwindow = window.open();
      this.$api.game
        .getnetarea()
        .then((data) => {
          if (data.status === 200) {
            // window.open(data.data + '/chargepageg/' + uuid, '_blank');
            tempwindow.location = data.data + '/chargepageg/' + uuid;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框的初始化
    dialoginit() {
      this.checkarea = [];
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    },
    // 删除行
    async deleteitem(data) {
      this.$api.game
        .groupdelete({
          groupId: data
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功!');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 删除选中行
    handleClose(data) {
      this.$confirm('删除分组将级联删除该分组下的所有分区,是否删除?')
        .then(() => {
          this.deleteitem(data);
        })
        .catch(() => {});
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.tableinfo {
  background: #fff;
  padding: 15px 20px;
  table {
    width: 100%;
    color: #272727;
    font-size: 14px;
    td {
      height: 30px;
    }
    .c_3fa396 {
      color: #3fa396;
    }
  }
}
.gs_tablebox {
  padding-bottom: 10px;
}
</style>
